import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { AWARD_QUERY_SEEN_ARCHIVE_ACTION_TYPE, AWARD_QUERY_SEEN_ARCHIVE_ALL_ACTION_TYPE, awardQuerySeenArchiveAllUrl, awardQuerySeenArchiveUrl, GET_AWARD_QUERY_NOTIFICATION_ACTION_TYPE, getAwardQueryNotificationUrl, headers, } from "../../utils/constants"

export const getAwardQueryNotification_action = (award_event_id) => async (dispatch) => {
    try {
        const mapdata = { user_id: sessionStorage.getItem('user_id'), award_event_id:award_event_id }
        const res = await axiosGet(getAwardQueryNotificationUrl, mapdata, headers);
        dispatch({
            type: GET_AWARD_QUERY_NOTIFICATION_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const award_query_seenArchive_action =
    (question_id, seen_type) =>
        async (dispatch) => {
            try {
                const mapdata = {
                    user_id: sessionStorage.getItem('user_id'),
                    award_event_id: sessionStorage.getItem('award_event_id'),
                    question_id: question_id,
                    seen_type: seen_type
                };
                const res = await axiosPost(awardQuerySeenArchiveUrl, mapdata, headers);
                dispatch({
                    type: AWARD_QUERY_SEEN_ARCHIVE_ACTION_TYPE,
                    payload: res,
                });
                return Promise.resolve(res);
            } catch (err) {
                return Promise.reject(err);
            }
        };

export const award_query_seenArchive_all_action =
    (seen_type) =>
        async (dispatch) => {
            try {
                const mapdata = {
                    user_id: sessionStorage.getItem('user_id'),
                    award_event_id: sessionStorage.getItem('award_event_id'),
                    seen_type: seen_type
                };
                const res = await axiosPost(awardQuerySeenArchiveAllUrl, mapdata, headers);
                dispatch({
                    type: AWARD_QUERY_SEEN_ARCHIVE_ALL_ACTION_TYPE,
                    payload: res,
                });
                return Promise.resolve(res);
            } catch (err) {
                return Promise.reject(err);
            }
        };
